/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { useThis } from "./useThis";

import type { Props } from "./props";
import type { FcWithChildren } from "types/fcWithChildren";

/*
TODO: 購入履歴ページのページネーション用のボタンコンポーネントとして実装
オフセットページネーションとLoad Moreで検討されていたが、かけられる工数の関係でLoad More一時的に採用
将来的にオフセットページネーションに変更する可能性あり
*/
export const BlackButton: FcWithChildren<Props> = (props) => {
  const { children, css: extendCss, type = "button", ...restProps } = props;
  const { applyStyles } = useThis({ css: extendCss });

  return (
    <button css={applyStyles} type={type} {...restProps}>
      {children}
    </button>
  );
};
